import { render, staticRenderFns } from "./MilestoneMessages.vue?vue&type=template&id=26da266f&"
import script from "./MilestoneMessages.vue?vue&type=script&lang=js&"
export * from "./MilestoneMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports